"use client";
import React from "react";
import { MentionChat } from "./MentionChat";

interface PromptFormProps {
  /**
   * Function to update the prompt text
   */
  setUserPrompt: (value: string) => void;

  /**
   * Form submission handler
   */
  handlePromptSubmit: (e: React.FormEvent) => void;

  /**
   * The currently selected HTML elements
   */
  selectedElements: HTMLElement[];
}

/**
 * Form component for entering and submitting prompts for selected elements
 */
export function PromptForm({
  setUserPrompt,
  handlePromptSubmit,
  selectedElements,
}: PromptFormProps) {
  return (
    <form onSubmit={handlePromptSubmit}>
      <div className="flex gap-2 items-center w-full">
        <div className="flex items-center relative gap-1.5 w-full">
          <MentionChat
            onSubmit={handlePromptSubmit}
            handleInputChange={setUserPrompt}
            selectedElements={selectedElements}
          />
        </div>
      </div>
    </form>
  );
}
